import { Breadcrumbs, Container, Grid, Link, useMediaQuery } from '@material-ui/core'
import { Splitter } from '@progress/kendo-react-layout';
import { TreeView, processTreeViewItems } from '@progress/kendo-react-treeview';
import React, { useEffect, useRef, useState } from 'react';
import { CheckBoxHLPure, GridSelectionHLPure, InputHLPure, SearchBarHLPure, SimpleLoading } from '../../pures';
import { filterBy } from '@progress/kendo-data-query';
import { CardViewIcon, FilterIcon, ListViewIcon } from '../../../assets/logos/icons';
import './digital-vault-subcategories.css';
import moment from "moment";
// import { aggregateFieldsIcon, fileAudioIcon, fileExcelIcon, fileImageIcon, filePdfIcon, filePptIcon, fileVideoIcon, fileWordIcon, folderIcon } from '@progress/kendo-svg-icons';
import { SvgIcon } from '@progress/kendo-react-common';

const findSubcategory = (tree, id, hierarchicalIndex = "", path = []) => {
    for (let i = 0; i < tree.length; i++) {
        const element = tree[i];
        if (element.subcategory.id == id) {
            return {
                subcategory: element,
                hierarchicalIndex: `${hierarchicalIndex}_${i}`.slice(1),
                path: [...path, element]
            };
        }
        const nextLevelSearch = findSubcategory(element.items || [], id, `${hierarchicalIndex}_${i}`, [...path, element])
        if (nextLevelSearch) return nextLevelSearch
    }
}

const getIconBasedOnFileType = (document) => {
    let fileIcon = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/FileDefault.svg"
    let aggregateFieldsIcon = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Proceedings.svg"
    let fileImageIcon = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Img.svg"
    let fileVideoIcon = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Video.svg"
    let fileAudioIcon = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/audio.svg"
    let filePdfIcon = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/PDFIcon.svg"
    let fileExcelIcon = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/ExcelIcon.svg"
    let filePptIcon = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/powerPointIcon.svg"
    let fileWordIcon = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/word.svg"

    if (document.infoType == 'Expediente') return aggregateFieldsIcon

    if (!document.file) return fileIcon
    if (document.file.mimeType.includes("image")) return fileImageIcon
    if (document.file.mimeType.includes("video")) return fileVideoIcon
    if (document.file.mimeType.includes("audio")) return fileAudioIcon

    let extension = document.file.fileName.split(".")
    extension = extension[extension.length - 1]

    if (extension == "pdf") return filePdfIcon
    if (["xlsx", "xlsm", "xlsb", "xltx", "xltm", "xls", "xlt", "xml", "xlam", "xla", "csv", "dif"].includes(extension)) return fileExcelIcon
    if (["doc", "docm", "docx", "dot", "dotm", "dotx"].includes(extension)) return fileWordIcon
    if (["pot", "potx", "ppa", "ppam", "pps", "ppsm", "ppsx", "ppt", "pttm", "pptx"].includes(extension)) return filePptIcon

    return fileIcon
}

const CellColumnOne = (props) => {
    let folderIcon = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Subcategories.svg"

    const {
        dataItem,
        onClick,
    } = props;

    let icon = getIconBasedOnFileType(dataItem); // tipo de archivo
    let name = dataItem.name;
    if (dataItem.subcategory) { // subcategoria
        icon = folderIcon
        name = dataItem.subcategory.name
    }
    return (
        <td onClick={() => onClick(dataItem)} className={`digitalVaultSubcategoriesView-col1 ${dataItem.subcategory ? "subcategory" : ""} ${dataItem.selected ? "selected" : ""}`}>
            <div className='digitalVaultSubcategoriesView-col1-content'>
                {/* <img
                    alt="profile-img"
                    src={icon}
                    className="digitalVaultSubcategoriesView-col1-icon"
                /> */}
                {/* <SvgIcon className="digitalVaultSubcategoriesView-col1-icon" icon={icon} /> */}
                <img src={icon} className="digitalVaultSubcategoriesView-col1-icon" />
                <div>
                    <p className='digitalVaultSubcategoriesView-col1-name'>{name}</p>
                </div>
            </div>
        </td>
    )
}

const CellColumnDate = (props) => {
    const {
        dataItem,
        onClick,
        column,
    } = props;

    let date = ""

    if (!dataItem.subcategory) {
        if (column == 2) {
            date = moment(dataItem.startDate);
        } else if (column == 4) {
            date = moment(dataItem.validation);
        }

        date = date.isValid() ? date.format("DD/MMM/YYYY") : ""
    }

    return (
        <td
            className={`digitalVaultSubcategoriesView-colDate digitalVaultSubcategoriesView-col${column} ${dataItem.selected ? "selected" : ""}`}
            onClick={() => onClick(dataItem)}
        >
            <div className={`digitalVaultSubcategoriesView-colDate-content`}>
                <p>{date}</p>
            </div>
        </td>
    )
}

const CellColumnThree = (props) => {
    const {
        dataItem,
        onClick,
    } = props;

    return (
        <td className={`digitalVaultSubcategoriesView-col3 ${dataItem.selected ? "selected" : ""}`} onClick={() => onClick(dataItem)} >
            <div className={`digitalVaultSubcategoriesView-col3-content`}>
                {
                    dataItem.subcategory
                        ? null
                        :
                        <CheckBoxHLPure
                            idCheckBox={dataItem.id}
                            checkedState={dataItem.mandatory == 'true'}
                            disabled
                        />
                }
            </div>
        </td>
    )
}

const DigitalVaultSubcategoriesView = (props) => {
    const {
        isLoading,
        gridIsLoading,
        breadcrumbItems,
        handleBreadcrumbClick,
        subcategoryTree,
        subcategoryData,
        currentSubcategory,
        setCurrentSubcategory,
        subcategoryPath,
        setSubcategoryPath,
        setSelectedDocument,
        t
    } = props;

    const showMobileView = useMediaQuery('(max-width: 800px)');
    const pageable = (subcategoryData.length + (currentSubcategory ? currentSubcategory.items.length : subcategoryTree.length)) < 28;
    const [panes, setPanes] = useState([
        {
            size: '20%',
            min: '100px',
            max: '500px',
            collapsible: true,
        },
        {},
    ]);
    const breadcrumbRef = useRef();
    const [viewDetails, setViewDetails] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [readOnly, setReadOnly] = useState(true)

    const [treeData, setTreeData] = useState(subcategoryTree);
    const [select, setSelect] = useState([""]);
    const [expand, setExpand] = useState({
        ids: [],
        idField: "subcategory.id",
    });

    const [documentSearch, setDocumentSearch] = useState("");
    let filter = {
        logic: "and",
        filters: [
            {
                field: "name",
                operator: "contains",
                value: documentSearch,
            },
        ],
    }

    const [subcategoryDataGrid, setSubcategoryDataGrid] = useState(subcategoryData);

    const searchGrid = () => {
        filter.filters[0].field = "name";
        let datadisplayed = filterBy(subcategoryData, filter); // filtra documentos
        filter.filters[0].field = "subcategory.name"
        if (currentSubcategory?.items) {
            const subcategoriesDisplayed = filterBy(currentSubcategory.items || [], filter); // filtra subcategorias
            datadisplayed = [...subcategoriesDisplayed, ...datadisplayed]
        } else if (!currentSubcategory && subcategoryTree.length) {
            const subcategoriesDisplayed = filterBy(subcategoryTree, filter); // filtra subcategorias
            datadisplayed = [...subcategoriesDisplayed, ...datadisplayed]
        }

        setSubcategoryDataGrid(datadisplayed);
    }

    const navigateToSubcategory = (subcategoryId, initial = false, expand = false) => {
        const { subcategory, hierarchicalIndex, path } = findSubcategory(treeData, subcategoryId);
        setSelect([hierarchicalIndex])
        if (initial && subcategoryPath.length) { // si se llega a la pantalla ya con un path (ej. regresar desde el documento)
            const expandedPath = subcategoryPath.slice(0, subcategoryPath.length - 1)
            setExpand({
                ids: expandedPath.map(s => s.subcategory.id),
                idField: 'subcategory.id'
            });
        }
        if (expand) { // para cuando se navega desde el grid
            setExpand(prev => ({
                ids: currentSubcategory ? [...prev.ids, currentSubcategory.subcategory.id] : [...prev.ids],
                idField: 'subcategory.id'
            }));
        }
        setCurrentSubcategory(subcategory);
        setSubcategoryPath(path);
    }

    useEffect(() => {
        onViewTypeChange(null, selectedRow !== null);
    }, [selectedRow])

    useEffect(() => {
        if (!subcategoryData) return;
        searchGrid();
    }, [subcategoryData]);

    useEffect(() => {
        setSelectedRow(null);
        searchGrid();
    }, [documentSearch]);

    useEffect(() => {
        setTreeData(subcategoryTree);
    }, [subcategoryTree])

    useEffect(() => {
        if (subcategoryPath.length == 0) {
            setCurrentSubcategory(null)
            setSelect([""]);
        }
    }, [subcategoryPath])

    useEffect(() => {
        if (!treeData || !treeData.length) return;
        if (subcategoryPath.length > 0) {
            const last = subcategoryPath[subcategoryPath.length - 1];
            navigateToSubcategory(last.subcategory.id, true);
        } else {
            setSubcategoryDataGrid(treeData)
        }
    }, [treeData]);

    const onTreeItemClick = (e) => {
        setSelectedRow(null);
        navigateToSubcategory(e.item.subcategory.id)
    }

    const onTreeExpandChange = (event) => {
        let ids = expand.ids.slice();
        const index = ids.indexOf(event.item.subcategory.id);
        index === -1 ? ids.push(event.item.subcategory.id) : ids.splice(index, 1);
        setExpand({
            ids,
            idField: "subcategory.id",
        });
    };

    const onViewTypeChange = (e, value) => {
        let showDetails = e ? e.target.value == "true" : value;
        let newPanes = panes.splice(0)
        if (showDetails) {
            newPanes.push({
                size: '30%',
                min: '150px',
                collapsible: false,
            })
        } else {
            if (newPanes > 2) {
                newPanes.pop()
            }
            setSelectedRow(null)
        }
        setPanes(newPanes)
        setViewDetails(showDetails)
    }

    const onBreadCrumbBack = () => {
        if (breadcrumbRef.current) {
            let items = breadcrumbRef.current.querySelectorAll("a")
            if (items.length > 1) {
                items[items.length - 2].click();
            }
        }
    }

    // Click en fila:
    // Desktop: muestra metadatos o entra a la subcategoría
    // Móvil: navega a pantalla de documento o entra a la subcategoría
    const onRowSelected = (dataItem) => {
        if (dataItem.subcategory) {
            navigateToSubcategory(dataItem.subcategory.id, false, true);
        } else if (dataItem.id) {
            if (showMobileView) {
                setSelectedDocument(dataItem);
            } else {
                setSelectedRow(dataItem);
            }
        }
    }

    // Click en ver detalle / flecha:
    // Navega a pantalla de documento o entra a la subcategoría
    const onViewDetails = (dataItem) => {
        setSelectedRow(null);
        if (dataItem.subcategory) {
            navigateToSubcategory(dataItem.subcategory.id);
        } else if (dataItem.id) { // es un documento
            setSelectedDocument(dataItem);
        }
    }

    const DocumentsColumnOne = (props) => <CellColumnOne {...props} onClick={onRowSelected} />
    const DocumentsColumnTwo = (props) => <CellColumnDate {...props} column={2} onClick={onRowSelected} />
    const DocumentsColumnThree = (props) => <CellColumnThree {...props} onClick={onRowSelected} />
    const DocumentsColumnFour = (props) => <CellColumnDate {...props} column={4} onClick={onRowSelected} />

    let skip = 0;
    if (selectedRow) {
        const i = subcategoryDataGrid.findIndex(d => d.id == selectedRow.id)
        if (i != -1) {
            skip = Math.floor(i / 6) * 6
        }
    }

    // const hideDateVersion = useMediaQuery('(max-width: 1100px)');
    const showShortHeader = useMediaQuery('(max-width: 900px)');
    const hideRequired = useMediaQuery('(max-width: 660px)');
    const hideLimitDate = useMediaQuery('(max-width: 560px)');

    if (isLoading) return <SimpleLoading />

    // separando componentes para poder cambiar entre vista móvil y desktop
    const tree = <TreeView
        data={processTreeViewItems(treeData, {
            select: select,
            expand: expand,
        })}
        expandIcons
        textField='subcategory.name'
        onExpandChange={onTreeExpandChange}
        onItemClick={onTreeItemClick}
    />

    const datagrid = gridIsLoading ? <SimpleLoading /> : <GridSelectionHLPure
        skip={skip}
        take={6}
        pageable={pageable}
        dataGrid={subcategoryDataGrid.map(i => ({ ...i, selected: i.id && i.id == selectedRow?.id }))}
        onRowClick={onRowSelected}

        titleRow1={t("digitalVaultSubcategoriesView.grid.title.1")}
        cellColumnOne={DocumentsColumnOne}
        isCheckedColOne={"name"}
        headerColumnOneClass={"digitalVaultSubcategoriesView-col1"}

        // columnTwo={!hideDateVersion}
        // titleRow2={"Fecha versión"}
        // cellColumnTwo={DocumentsColumnTwo}
        // headerColumnTwoClass={"digitalVaultSubcategoriesView-col2"}

        columnThree={!viewDetails && !hideRequired}
        titleRow3={t("digitalVaultSubcategoriesView.grid.title.2")}
        cellColumnThree={DocumentsColumnThree}
        headerColumnThreeClass={"digitalVaultSubcategoriesView-col3"}

        columnFour={!viewDetails && !hideLimitDate}
        titleRow4={showShortHeader ? t("digitalVaultSubcategoriesView.grid.title.4.short") : t("digitalVaultSubcategoriesView.grid.title.4")}
        cellColumnFour={DocumentsColumnFour}
        headerColumnFourClass={"digitalVaultSubcategoriesView-col4"}

        columnFive
        columnFiveStyleClass={"digitalVaultSubcategoriesView-cellActions"}
        titleRow5={""}
        widthColumnFive={showMobileView ? 40 : 115}
        iconOneActive
        labelOneActions={t("digitalVaultSubcategoriesView.btn.detail")}
        onSelectedItem={onViewDetails}
        setNameComponentUser={() => { /* no ocupo */ }}
        setShowDetails={() => { /* no ocupo */ }}
    />

    return (
        <Container disableGutters className='digitalVaultSubcategoriesView'>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Grid container className='digitalVaultSubcategoriesView-filters'>
                        {
                            showMobileView
                                ? <button onClick={onBreadCrumbBack} className='digitalVaultSubcategoriesView-back' aria-label='Regresar'>
                                    &#129128;
                                </button>
                                : <span aria-hidden='true' className='hidden'></span>
                        }
                        <Grid item>
                            <SearchBarHLPure
                                readOnly={readOnly}
                                onFocus={() => setReadOnly(false)}
                                onBlur={() => setReadOnly(true)}
                                placeholder={t("digitalVaultSubcategoriesView.btn.search")}
                                value={documentSearch}
                                onSearchChange={(e) => setDocumentSearch(e.target.value)}
                            />
                        </Grid>
                        {
                            !showMobileView &&
                            <Grid item role="radiogroup" aria-label="Ver detalle de documentos" className='digitalVaultView-viewType'>
                                <label className='digitalVaultView-viewType-option' aria-label='No'>
                                    <input type="radio" name="view" value="false" checked={!viewDetails} onChange={onViewTypeChange} />
                                    <span className='digitalVaultView-viewType-img'>
                                        <img aria-hidden='true' src="https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Table view.svg" />
                                    </span>
                                </label>
                                <label className='digitalVaultView-viewType-option' aria-label='Sí'>
                                    <input type="radio" name="view" value="true" checked={viewDetails} onChange={onViewTypeChange} />
                                    <span className='digitalVaultView-viewType-img listview'>
                                        <img aria-hidden='true' src="https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/DetailsViews.svg" />
                                    </span>
                                </label>
                            </Grid>
                        }
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Breadcrumbs innerRef={breadcrumbRef} maxItems={4} itemsBeforeCollapse={2} itemsAfterCollapse={2} aria-label="Categorías">
                        {
                            breadcrumbItems.map((item, i) => <Link
                                href="#"
                                onClick={(e) => {
                                    setSelectedRow(null);
                                    if (i > 1) navigateToSubcategory(item.id)
                                    handleBreadcrumbClick(e, item);
                                }}
                                aria-current="page"
                            >
                                {item.title}
                            </Link>)
                        }
                    </Breadcrumbs>
                </Grid>
                <Grid item xs={12}>
                    {
                        showMobileView
                            ? <>
                                <div style={{ display: 'none' }}>{tree}</div>
                                <div className={`digitalVaultSubcategoriesView-grid ${pageable ? null : "scroll"}`}>
                                    {datagrid}
                                </div>
                            </>
                            : <Splitter panes={panes} onChange={(e) => setPanes(e.newState)}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <p className='digitalVaultSubcategoriesView-label'>{t("digitalVaultSubcategoriesView.labels.subcategories")}</p>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {tree}
                                    </Grid>
                                </Grid>
                                <div className={`digitalVaultSubcategoriesView-grid ${pageable ? null : "scroll"}`}>
                                    {datagrid}
                                </div>
                                {viewDetails && !gridIsLoading &&
                                    <Grid container className='digitalVaultSubcategoriesView-metadata'>
                                        {
                                            selectedRow &&
                                            <>
                                                <Grid item xs={12}>
                                                    <p className='digitalVaultSubcategoriesView-label'>{t("digitalVaultSubcategoriesView.label.metadata")}</p>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <InputHLPure
                                                        readOnlyText={selectedRow.name}
                                                        labelInput={t("digitalVaultSubcategoriesView.label.name.doc")}
                                                        typeInput="text"
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <InputHLPure
                                                        readOnlyText={selectedRow.alias}
                                                        labelInput={t("digitalVaultSubcategoriesView.label.alias")}
                                                        typeInput="text"
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <InputHLPure
                                                        readOnlyText={selectedRow.tags}
                                                        labelInput={t("digitalVaultSubcategoriesView.label.tags")}
                                                        typeInput="text"
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <InputHLPure
                                                        readOnlyText={selectedRow.nameUser}
                                                        labelInput={t("digitalVaultSubcategoriesView.label.owner")}
                                                        typeInput="text"
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <InputHLPure
                                                        readOnlyText={selectedRow.description}
                                                        labelInput={t("digitalVaultSubcategoriesView.label.description")}
                                                        typeInput="text"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} className='digitalVaultSubcategoriesView-variables'>
                                                    <p className='inputHLPure-label'>{t("digitalVaultSubcategoriesView.label.vars")}</p>
                                                    <ul>
                                                        {
                                                            selectedRow.variables.map(item => <li key={item.id}>
                                                                <p><span>{item.variable.variableName}</span>: {item.valueVariable}</p>
                                                            </li>)
                                                        }
                                                    </ul>
                                                </Grid>
                                            </>
                                        }
                                    </Grid>
                                }
                            </Splitter>
                    }
                </Grid>
            </Grid>
        </Container>
    )
}

export default DigitalVaultSubcategoriesView